import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';
import Button from '../components/shared/Button/Button';

const NotFound: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-50 text-brand-700">
        <Compass className="h-8 w-8" aria-hidden />
      </div>
      <p className="mt-6 text-base font-semibold tracking-wider text-brand-700">
        404
      </p>
      <h1 className="mt-2 text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
        Page not found
      </h1>
      <p className="mt-3 max-w-md text-base text-slate-600">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link to="/">
          <Button icon={<ArrowLeft className="h-4 w-4" />}>Back to home</Button>
        </Link>
        <Link to="/admin">
          <Button variant="secondary">Admin panel</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
